import React from "react";
import { Footer } from "../../components";

const PartnerLegal: React.FC = () => {
  return (
    <div className="bg-green-900 min-h-screen text-white flex flex-col font-sans">
      <section className="py-16 px-6 text-center bg-green-800">
        <h1 className="text-4xl md:text-5xl font-extrabold text-yellow-400">
          Conditions d’Affiliation Pharmacies Partenaires
        </h1>
        <p className="mt-4 text-lg text-gray-200 max-w-2xl mx-auto">
          Informations légales pour les pharmacies souhaitant rejoindre Mediiq.
        </p>
      </section>

      <section className="flex-grow px-6 md:px-16 py-10 space-y-10 text-gray-100">

        <div>
          <h2 className="text-2xl font-semibold text-green-300 mb-2">1. Exigences légales</h2>
          <p>
            Toute pharmacie souhaitant rejoindre Mediiq doit fournir :
          </p>
          <ul className="list-disc ml-6 mt-2">
            <li>Un certificat d’ouverture valide</li>
            <li>Une identification légale reconnue par l’État</li>
            <li>Le nom et le contact du pharmacien responsable</li>
          </ul>
        </div>

        <div>
          <h2 className="text-2xl font-semibold text-green-300 mb-2">2. Responsabilité du partenaire</h2>
          <p>
            Le partenaire est entièrement responsable :
          </p>
          <ul className="list-disc ml-6 mt-2">
            <li>De la conformité des médicaments vendus</li>
            <li>Du traitement et de la validation des ordonnances</li>
            <li>De la livraison (si fournie)</li>
            <li>Du respect des normes pharmaceutiques nationales</li>
          </ul>
        </div>

        <div>
          <h2 className="text-2xl font-semibold text-green-300 mb-2">3. Rôle de Mediiq</h2>
          <p>
            Mediiq est une plateforme de mise en relation gérée par 
            <strong> Loven Software Development SARL U</strong>.
          </p>
          <p>
            Mediiq ne délivre pas de médicaments et ne remplace pas les obligations légales des pharmacies.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-semibold text-green-300 mb-2">4. Suspension</h2>
          <p>
            En cas de non-respect des règles ou de risques pour les utilisateurs, Mediiq peut suspendre un partenaire.
          </p>
        </div>

      </section>

      <Footer />
    </div>
  );
};

export default PartnerLegal;
